import "./TheThesis.module.css";
import Header from "@/reusable_sections/Header";
import TheIntelligenceSupercycle from "./sections/TheIntelligenceSupercycle";
import InvestmentPillars from "./sections/InvestmentPillars";
import MarketInsights from "./sections/MarketInsights";
import Footer from "@/reusable_sections/Footer";
export default function TheThesisPage() {
  return <div>
      <Header />
      <TheIntelligenceSupercycle />
      <InvestmentPillars />
      <MarketInsights />
      <Footer />
    </div>;
}